import { ISendAdtNotification } from "./types";
import { apiPrivateAxios } from "../../axios";

const adtNotificationRequest = {
  sendAdtNotification: (data: ISendAdtNotification): Promise<void> =>
    apiPrivateAxios.post("/adt-notification/send-manually", data),
};

export default adtNotificationRequest;
